import i18n from '@/plugins/languages/i18n'
import Vue from 'vue'

let validation = new Vue({

  methods: {
    focusInputError (component) {
      if (component.inputError) {
        component.$refs[component.reference].focus()
        return true
      }
      let focus = false
      component.$children.some((childComponent) => {
        focus = this.focusInputError(childComponent)
        return focus
      })
      return focus
    },

    getValidationMessage (translation, fieldVState, field, childField = null) {
      if (fieldVState.$error) {
        let rules = childField === null ? i18n.messages[i18n.locale][translation]['validation'][field] : i18n.messages[i18n.locale][translation]['validation'][field][childField]
        for (const rule in rules) {
          if (!fieldVState[rule]) {
            return childField === null ? i18n.t(`${translation}.validation.${field}.${rule}`) : i18n.t(`${translation}.validation.${field}.${childField}.${rule}`)
          }
        }
      }
    }
  }
})

export default {
  install: (Vue) => {
    Vue.prototype.$validation = validation
  }
}
